import {orderTypes, paymentProviderTypes} from 'app/constant'
import {PAYMENT_TYPES} from 'app/constant/payment'
import {FC} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  selectOrderTransactionPaymentType,
  selectViewOrder,
} from 'app/features/orders/redux/order/orderSlice'
import ElavonRefundButton from './ElavonRefundButton'
import {ViewOrder} from 'app/features/orders/models/OrderState'

interface Props {
  title?: string
  className?: string
  children: React.ReactNode
  isRefundAndRestock?: boolean
  currentState: {
    sendEmail: boolean
    reason: string
  }
  onClose: () => void
}

const ActionButton: FC<Props> = ({
  title = 'Yes, proceed',
  className = 'btn btn-primary btn-sm ms-5',
  children,
  isRefundAndRestock,
  ...props
}) => {
  const paymentType = useSelector<RootState, string>(selectOrderTransactionPaymentType)
  const user = useSelector<RootState, any>(({auth}) => auth.user)
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  if (user && isRefundAndRestock && order.orderType === orderTypes.POS) {
    const {store, locationId} = user
    if (
      paymentType === PAYMENT_TYPES.scanner &&
      store.paymentProviderType === paymentProviderTypes.elavon
    ) {
      return (
        <ElavonRefundButton
          locationId={locationId}
          title={title}
          className={className}
          {...props}
        />
      )
    }
  }

  return <>{children}</>
}

export default ActionButton
